import React from 'react';

interface SliderProps {
  label: string;
  id: string;
  min: number;
  max: number;
  step: number;
  value: number;
  onStartEditing?: () => void;
  onChange: (value: number) => void;
  onEndEditing?: () => void;

}

const SliderControl: React.FC<SliderProps> = ({ label, id, min, max, step, value, onChange, onStartEditing, onEndEditing }) => {
  return (
    <div className="mb-4">
      <label htmlFor={id} className="block mt-4 mb-2 text-xs font-medium text-gray-800 dark:text-white">
        {label}
      </label>
      <input
        type="range"
        id={id}
        name={id}
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        onMouseDown={onStartEditing}
        onMouseUp={onEndEditing}
        onMouseLeave={onEndEditing}
        className="block mb-2 text-sm font-medium text-gray-900 dark:text-white appearance-none bg-transparent [&::-webkit-slider-runnable-track]:rounded-full [&::-webkit-slider-runnable-track]:bg-red"
        
      />
    </div>
  );
};

export default SliderControl;